import { render, staticRenderFns } from "./checkboxOff.vue?vue&type=template&id=acf68440&scoped=true&"
var script = {}
import style0 from "./checkboxOff.vue?vue&type=style&index=0&id=acf68440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf68440",
  null
  
)

export default component.exports